import ApiService from './ApiService';

class PageNoteApi extends ApiService {
    constructor() {
        super('page-notes');
    }

    getPageNotes(payload?: any) {
        return this.get('', payload);
    }

    createPageNote(payload: { publicationId: number, pageNumber: number, highlight: string, content: string, position: string }) {
        return this.post('', payload);
    }

    deletePageNote(id: string | number) {
        return this.delete(`${id}`);
    }
}

const pageNoteApi = new PageNoteApi();
export default pageNoteApi;
